import {EventConstants} from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import Store from 'lib/Store';

import * as BulkAntibodyConstants from './BulkAntibodyConstants';
import * as BulkAntibodyUtil from './BulkAntibodyUtil';

class BulkAntibodyStore extends Store {
  resetState() {
    // TODO(T8838): Default to "Antibody" tag schema
    // Supports one bulk antibody at a time
    this.bulkAntibody = BulkAntibodyUtil.createBulkAntibody();
  }

  getBulkAntibody() {
    return this.bulkAntibody;
  }

  payloadHandler(action) {
    switch (action.actionType) {
      case EventConstants.BULK_ANTIBODY_UPDATE: {
        this.bulkAntibody = BulkAntibodyUtil.Update.update(this.bulkAntibody, action.updates);
        this.emitChange();
        break;
      }
      case EventConstants.BULK_TRANSLATE_RUN_COMPLETED: {
        // Fetch the files in the protein folder from the bulk translation step
        //
        // TODO: Move into a `BulkAntibodyActions.runBulkTranslation` action
        const BulkAntibodyActions = require('./BulkAntibodyActions');
        BulkAntibodyActions.fetchInputFiles(action.proteinFolderId);

        this.bulkAntibody = BulkAntibodyUtil.Update.update(this.bulkAntibody, {
          outputFolderId: action.outputFolderId,
          step: BulkAntibodyConstants.Step.BULK_ANTIBODY,
        });
        this.emitChange();
        break;
      }
      default:
        break;
    }
  }
}

const bulkAntibodyStore = new BulkAntibodyStore(AppDispatcher);
export default bulkAntibodyStore;
